module.exports = __webpack_public_path__ + "static/img/34.57594b1d.png";